import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid="not-found-page">
      <div className="text-center">
        <div className="font-[Outfit] text-7xl text-white font-light">404</div>
        <div className="mt-3 text-slate-400">This page slipped through our diversification.</div>
        <Link to="/" className="btn-primary mt-6 inline-flex">Back to Home</Link>
      </div>
    </div>
  );
}
